export const STARS = [
  {
    id: 1,
    rateKey: 'periodical_evaluation.rating.need_more_effort',
    rate: 'Need more effort',
    color: '',
  },
  {
    id: 2,
    rateKey: 'periodical_evaluation.rating.need_improvement',
    rate: 'Need more improvement',
    color: '',
  },
  {
    id: 3,
    rateKey: 'periodical_evaluation.rating.average',
    rate: 'Average',
    color: '',
  },
  {
    id: 4,
    rateKey: 'periodical_evaluation.rating.good',
    rate: 'Good',
    color: '#ffb320',
  },
  {
    id: 5,
    rateKey: 'periodical_evaluation.rating.excellent',
    rate: 'Excellent',
    color: '#ffb320',
  },
];

export const LISTENING = [
  {
    id: 1,
    nameKey: 'periodical_evaluation.listen.grammar',
    name: 'Avoid grammatical mistakes',
    value: 'gramma',
    star: 3,
  },
  {
    id: 2,
    nameKey: 'periodical_evaluation.listen.receptive',
    name: 'Second Language Acquisition',
    value: 'receptive',
    star: 3,
  },

  {
    id: 3,
    nameKey: 'periodical_evaluation.listen.attitude',
    name: 'Attitude towards English learning',
    value: 'attitude',
    star: 3,
  },
];
export const WRITING = [
  {
    id: 1,
    nameKey: 'periodical_evaluation.write.phrasal_verbs',
    name: 'Use phrasal verbs and collocations',
    value: 'phrasal_verbs_combination',
    star: 3,
  },
  {
    id: 2,
    nameKey: 'periodical_evaluation.write.vocabulary',
    name: 'Use a wide range of vocabulary',
    value: 'wide_range_vocabulary',
    star: 3,
  },

  {
    id: 3,
    nameKey: 'periodical_evaluation.write.grammar_variety',
    name: 'Use a variety of grammatical forms',
    value: 'variety_grammar_types',
    star: 3,
  },
];
export const SPEAKING = [
  {
    id: 1,
    nameKey: 'periodical_evaluation.speak.avoid_silence',
    name: 'Avoid silence or hesitation',
    value: 'avoid_silence_hesitati',
    star: 3,
  },
  {
    id: 2,
    nameKey: 'periodical_evaluation.speak.talk_long',
    name: 'Speak at length on each topic',
    value: 'talk_long_topic',
    star: 3,
  },

  {
    id: 3,
    nameKey: 'periodical_evaluation.speak.pronunciation',
    name: 'Pronounce accurately',
    value: 'pronunciation',
    star: 3,
  },
];
export const READING = [
  {
    id: 1,
    nameKey: 'periodical_evaluation.read.avoid_mistakes',
    name: 'Avoid grammatical mistakes',
    value: 'avoid_mistakes',
    star: 3,
  },
  {
    id: 2,
    nameKey: 'periodical_evaluation.read.receptive',
    name: 'Second Language Acquisition',
    value: 'receptive',
    star: 3,
  },

  {
    id: 3,
    nameKey: 'periodical_evaluation.read.attitude',
    name: 'Attitude towards English learning',
    value: 'attitude',
    star: 3,
  },
];
export const RATINGS = [
  {
    id: 1,
    nameKey: 'periodical_evaluation.listen',
    name: 'Listen',
    value: LISTENING,
    dataName: 'listen',
  },
  {
    id: 2,
    nameKey: 'periodical_evaluation.speak',
    name: 'Speak',
    value: SPEAKING,
    dataName: 'speak',
  },

  {
    id: 3,
    nameKey: 'periodical_evaluation.read',
    name: 'Read',
    value: READING,
    dataName: 'read',
  },
  {
    id: 4,
    nameKey: 'periodical_evaluation.write',
    name: 'Write',
    value: WRITING,
    dataName: 'write',
  },
];
